import { ResponseCode } from 'data/api/response-codes';
import { isObject, isValueInObject } from 'libs/utils/object';
export function isAxiosResponse(response) {
  return response != null && isObject(response) && 'data' in response && 'status' in response && 'statusText' in response && 'headers' in response && 'config' in response && 'request' in response;
}
export function isAxiosError(error) {
  return error === null || error === void 0 ? void 0 : error.isAxiosError;
}
export const extractErrorResponseCode = error => {
  var _error$response;

  if (!isAxiosError(error)) return undefined;
  const responseData = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
  if (!isObject(responseData)) return undefined;
  if (!('code' in responseData)) return undefined;
  const {
    code
  } = responseData;
  if (typeof code !== 'number') return undefined;
  if (!isValueInObject(code, ResponseCode)) return undefined;
  return code;
};